export const PENDING_FOLLOW_UP_STATUSES = new Set(['pending', 'scheduled']);
export const HISTORY_FOLLOW_UP_STATUSES = new Set([
  'sent',
  'failed',
  'cancelled',
]);

export const isPendingFollowUpStatus = status =>
  PENDING_FOLLOW_UP_STATUSES.has(status);

export const isHistoryFollowUpStatus = status =>
  HISTORY_FOLLOW_UP_STATUSES.has(status);
